module.exports = __webpack_public_path__ + "assets/echarts.e63cc1e1.svg";